import React, { useEffect, useState } from 'react';
import AdminSidebar from '../components/AdminSidebar';
import api from '../api';
import { CURRENCIES } from '../utils/currency';

const AdminSettings = () => {
  const [settings, setSettings] = useState({
    site_name: '',
    logo_text: '',
    logo_color_1: '#1a1a1a',
    logo_color_2: '#c9a96e',
    hero_title: '',
    hero_subtitle: '',
    hero_image: '',
    hero_image_mobile: '',
    logo_image: '',
    primary_color: '#1a1a1a',
    accent_color: '#c9a96e',
    button_text: '',
    hero_button_enabled: '1',
    hero_title_color: '#ffffff',
    section_title_color: '#1a1a1a',
    currency: 'MAD',
    whatsapp_number: '',
    paypal_client_id: '',
    paypal_currency: 'USD',
  });
  const [saving, setSaving] = useState(false);
  const [alert, setAlert] = useState(null);
  const [heroFile, setHeroFile] = useState(null);
  const [heroPreview, setHeroPreview] = useState(null);
  const [heroMobileFile, setHeroMobileFile] = useState(null);
  const [heroMobilePreview, setHeroMobilePreview] = useState(null);
  const [logoFile, setLogoFile] = useState(null);
  const [logoPreview, setLogoPreview] = useState(null);

  // ✅ NOUVEAU
  const [cashOnDelivery, setCashOnDelivery] = useState(false);
  const [codSaving, setCodSaving] = useState(false);

  useEffect(() => {
    api.get('/api/settings').then(({ data }) => {
      setSettings(s => ({ ...s, ...data.data }));
      if (data.data.hero_image) setHeroPreview(data.data.hero_image);
      if (data.data.hero_image_mobile) setHeroMobilePreview(data.data.hero_image_mobile);
      if (data.data.logo_image) setLogoPreview(data.data.logo_image);
      // ✅ NOUVEAU
      setCashOnDelivery(data.data.cash_on_delivery === '1');
    });
  }, []);

  // ✅ NOUVEAU
  const handleToggleCOD = async () => {
    const newValue = !cashOnDelivery;
    setCashOnDelivery(newValue);
    setCodSaving(true);
    try {
      await api.post('/api/settings/toggle-cash-on-delivery', { enabled: newValue });
      setAlert({ type: 'success', msg: `Paiement à la livraison ${newValue ? 'activé' : 'désactivé'} ✅` });
    } catch (err) {
      console.error(err);
      setCashOnDelivery(!newValue); // rollback
      setAlert({ type: 'error', msg: 'Erreur lors de la mise à jour.' });
    } finally {
      setCodSaving(false);
    }
  };

  const handleSave = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      let updatedSettings = { ...settings };

      if (heroFile) {
        const fd = new FormData();
        fd.append('image', heroFile);
        const { data } = await api.post('/api/settings/hero-image', fd, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
        if (data.image_url) {
          setHeroPreview(data.image_url);
          updatedSettings.hero_image = data.image_url;
        }
      }
      if (heroMobileFile) {
        const fd = new FormData();
        fd.append('image', heroMobileFile);
        const { data } = await api.post('/api/settings/hero-image-mobile', fd, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
        if (data.image_url) {
          setHeroMobilePreview(data.image_url);
          updatedSettings.hero_image_mobile = data.image_url;
        }
      }
      if (logoFile) {
        const fd = new FormData();
        fd.append('image', logoFile);
        const { data } = await api.post('/api/settings/logo-image', fd, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
        if (data.image_url) {
          setLogoPreview(data.image_url);
          updatedSettings.logo_image = data.image_url;
        }
      }

      await api.put('/api/settings', updatedSettings);
      setSettings(updatedSettings);
      setHeroFile(null);
      setHeroMobileFile(null);
      setLogoFile(null);
      setAlert({ type: 'success', msg: 'Paramètres sauvegardés ✅' });
    } catch (err) {
      console.error(err);
      setAlert({ type: 'error', msg: 'Erreur lors de la sauvegarde.' });
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="admin-layout">
      <AdminSidebar />
      <main className="admin-main">
        <div className="admin-header">
          <h1>Paramètres du site</h1>
          <p>Personnalisez votre boutique sans toucher au code.</p>
        </div>

        {alert && (
          <div className={`alert alert-${alert.type === 'success' ? 'success' : 'error'}`} style={{ marginBottom: '1rem' }}>
            {alert.msg}
            <button onClick={() => setAlert(null)} style={{ float: 'right', background: 'none', border: 'none', cursor: 'pointer' }}>✕</button>
          </div>
        )}

        <form onSubmit={handleSave}>

          {/* Logo */}
          <div className="card" style={{ padding: '2rem', marginBottom: '1.5rem' }}>
            <h2 style={{ marginBottom: '1.5rem' }}>🏪 Logo & Nom du site</h2>
            <div className="form-group">
              <label>Nom du site (texte)</label>
              <input className="form-control" value={settings.site_name}
                onChange={e => setSettings(s => ({ ...s, site_name: e.target.value }))} />
            </div>
            <div className="form-group">
              <label>Texte du logo dans la navbar</label>
              <input className="form-control" value={settings.logo_text}
                onChange={e => setSettings(s => ({ ...s, logo_text: e.target.value }))}
                placeholder="ex: MonShop" />
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
              <div className="form-group">
                <label>Couleur 1ère lettre du logo</label>
                <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
                  <input type="color" value={settings.logo_color_1}
                    onChange={e => setSettings(s => ({ ...s, logo_color_1: e.target.value }))}
                    style={{ width: 50, height: 40, border: 'none', cursor: 'pointer' }} />
                  <input className="form-control" value={settings.logo_color_1}
                    onChange={e => setSettings(s => ({ ...s, logo_color_1: e.target.value }))} />
                </div>
              </div>
              <div className="form-group">
                <label>Couleur reste du logo</label>
                <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
                  <input type="color" value={settings.logo_color_2}
                    onChange={e => setSettings(s => ({ ...s, logo_color_2: e.target.value }))}
                    style={{ width: 50, height: 40, border: 'none', cursor: 'pointer' }} />
                  <input className="form-control" value={settings.logo_color_2}
                    onChange={e => setSettings(s => ({ ...s, logo_color_2: e.target.value }))} />
                </div>
              </div>
            </div>
            <div className="form-group" style={{ marginTop: '1rem' }}>
              <label>Image du logo (optionnel — remplace le texte)</label>
              <input type="file" accept="image/*" className="form-control"
                onChange={e => {
                  const file = e.target.files[0];
                  if (!file) return;
                  setLogoFile(file);
                  setLogoPreview(URL.createObjectURL(file));
                }} style={{ padding: '.5rem' }} />
              {logoPreview && (
                <img src={logoPreview} alt="Logo preview"
                  style={{ marginTop: '1rem', height: 60, objectFit: 'contain', borderRadius: 8, background: '#f0ede8', padding: '0.5rem' }} />
              )}
            </div>
          </div>

          {/* Hero */}
          <div className="card" style={{ padding: '2rem', marginBottom: '1.5rem' }}>
            <h2 style={{ marginBottom: '1.5rem' }}>🖼️ Page d'accueil (Hero)</h2>
            <div className="form-group">
              <label>Titre principal</label>
              <input className="form-control" value={settings.hero_title}
                onChange={e => setSettings(s => ({ ...s, hero_title: e.target.value }))} />
            </div>
            <div className="form-group">
              <label>Sous-titre</label>
              <input className="form-control" value={settings.hero_subtitle}
                onChange={e => setSettings(s => ({ ...s, hero_subtitle: e.target.value }))} />
            </div>
            <div className="form-group">
              <label>Texte du bouton</label>
              <input className="form-control" value={settings.button_text}
                onChange={e => setSettings(s => ({ ...s, button_text: e.target.value }))} />
            </div>
            <div className="form-group" style={{ marginTop: '1rem' }}>
              <label style={{ display: 'flex', alignItems: 'center', gap: '1rem', cursor: 'pointer' }}>
                <span>Afficher le bouton sur le Hero</span>
                <div
                  onClick={() => setSettings(s => ({ ...s, hero_button_enabled: s.hero_button_enabled === '1' ? '0' : '1' }))}
                  style={{
                    width: 52, height: 28, borderRadius: 14, cursor: 'pointer', transition: 'background .2s',
                    background: settings.hero_button_enabled === '1' ? '#1a1a1a' : '#d1d5db',
                    position: 'relative', flexShrink: 0,
                  }}
                >
                  <div style={{
                    position: 'absolute', top: 3, left: settings.hero_button_enabled === '1' ? 26 : 3,
                    width: 22, height: 22, borderRadius: '50%', background: 'white',
                    transition: 'left .2s', boxShadow: '0 1px 4px rgba(0,0,0,0.2)',
                  }} />
                </div>
                <span style={{ color: settings.hero_button_enabled === '1' ? '#1a1a1a' : '#9ca3af', fontWeight: 600 }}>
                  {settings.hero_button_enabled === '1' ? 'Activé' : 'Désactivé'}
                </span>
              </label>
            </div>
            <div className="form-group">
              <label>Photo de fond du Hero</label>
              <input type="file" accept="image/*" className="form-control"
                onChange={e => {
                  const file = e.target.files[0];
                  if (!file) return;
                  setHeroFile(file);
                  setHeroPreview(URL.createObjectURL(file));
                }} style={{ padding: '.5rem' }} />
              {heroPreview && (
                <img src={heroPreview} alt="Hero preview"
                  style={{ marginTop: '1rem', width: '100%', maxHeight: 200, objectFit: 'cover', borderRadius: 8 }} />
              )}
            </div>
            <div className="form-group" style={{ marginTop: '1rem' }}>
              <label>📱 Photo de fond Mobile (vertical, ex: 600×900)</label>
              <input type="file" accept="image/*" className="form-control"
                onChange={e => {
                  const file = e.target.files[0];
                  if (!file) return;
                  setHeroMobileFile(file);
                  setHeroMobilePreview(URL.createObjectURL(file));
                }} style={{ padding: '.5rem' }} />
              {heroMobilePreview && (
                <img src={heroMobilePreview} alt="Hero mobile preview"
                  style={{ marginTop: '1rem', width: 160, maxHeight: 280, objectFit: 'cover', borderRadius: 8 }} />
              )}
            </div>
          </div>

          {/* Couleurs */}
          <div className="card" style={{ padding: '2rem', marginBottom: '1.5rem' }}>
            <h2 style={{ marginBottom: '1.5rem' }}>🎨 Couleurs</h2>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
              <div className="form-group">
                <label>Couleur principale</label>
                <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
                  <input type="color" value={settings.primary_color}
                    onChange={e => setSettings(s => ({ ...s, primary_color: e.target.value }))}
                    style={{ width: 50, height: 40, border: 'none', cursor: 'pointer' }} />
                  <input className="form-control" value={settings.primary_color}
                    onChange={e => setSettings(s => ({ ...s, primary_color: e.target.value }))} />
                </div>
              </div>
              <div className="form-group">
                <label>Couleur accent</label>
                <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
                  <input type="color" value={settings.accent_color}
                    onChange={e => setSettings(s => ({ ...s, accent_color: e.target.value }))}
                    style={{ width: 50, height: 40, border: 'none', cursor: 'pointer' }} />
                  <input className="form-control" value={settings.accent_color}
                    onChange={e => setSettings(s => ({ ...s, accent_color: e.target.value }))} />
                </div>
              </div>
              <div className="form-group">
                <label>Couleur titre Hero</label>
                <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
                  <input type="color" value={settings.hero_title_color}
                    onChange={e => setSettings(s => ({ ...s, hero_title_color: e.target.value }))}
                    style={{ width: 50, height: 40, border: 'none', cursor: 'pointer' }} />
                  <input className="form-control" value={settings.hero_title_color}
                    onChange={e => setSettings(s => ({ ...s, hero_title_color: e.target.value }))} />
                </div>
              </div>
              <div className="form-group">
                <label>Couleur titres de section</label>
                <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
                  <input type="color" value={settings.section_title_color}
                    onChange={e => setSettings(s => ({ ...s, section_title_color: e.target.value }))}
                    style={{ width: 50, height: 40, border: 'none', cursor: 'pointer' }} />
                  <input className="form-control" value={settings.section_title_color}
                    onChange={e => setSettings(s => ({ ...s, section_title_color: e.target.value }))} />
                </div>
              </div>
            </div>
          </div>

          {/* WhatsApp */}
          <div className="card" style={{ padding: '2rem', marginBottom: '1.5rem' }}>
            <h2 style={{ marginBottom: '1.5rem' }}>💬 Bouton WhatsApp</h2>
            <p style={{ color: '#888', fontSize: '.9rem', marginBottom: '1.25rem' }}>
              Un bouton flottant vert apparaîtra sur toutes les pages du site. Laissez vide pour le désactiver.
            </p>
            <div className="form-group">
              <label>Numéro WhatsApp (avec indicatif pays)</label>
              <input className="form-control" value={settings.whatsapp_number}
                onChange={e => setSettings(s => ({ ...s, whatsapp_number: e.target.value }))}
                placeholder="ex: +212612345678" />
              <p style={{ color: '#aaa', fontSize: '.82rem', marginTop: '.4rem' }}>
                Format international requis : +212 pour le Maroc, +33 pour la France...
              </p>
            </div>
          </div>

          {/* PayPal */}
          <div className="card" style={{ padding: '2rem', marginBottom: '1.5rem' }}>
            <h2 style={{ marginBottom: '1.5rem' }}>💳 Paiement PayPal</h2>
            <p style={{ color: '#888', fontSize: '.9rem', marginBottom: '1.25rem' }}>
              Activez le paiement PayPal sur vos pages produits. Laissez vide pour désactiver.
            </p>
            <div className="form-group">
              <label>PayPal Client ID</label>
              <input className="form-control" value={settings.paypal_client_id}
                onChange={e => setSettings(s => ({ ...s, paypal_client_id: e.target.value }))}
                placeholder="AYour_PayPal_Client_ID_Here..."
                style={{ fontFamily: 'monospace', fontSize: '.85rem' }} />
              <p style={{ color: '#aaa', fontSize: '.82rem', marginTop: '.4rem' }}>
                Trouvez votre Client ID sur <strong>developer.paypal.com</strong> → My Apps → votre app
              </p>
            </div>
            <div className="form-group">
              <label>Devise PayPal</label>
              <select className="form-control" value={settings.paypal_currency}
                onChange={e => setSettings(s => ({ ...s, paypal_currency: e.target.value }))}>
                <option value="USD">USD — Dollar américain</option>
                <option value="EUR">EUR — Euro</option>
                <option value="GBP">GBP — Livre sterling</option>
              </select>
              <p style={{ color: '#aaa', fontSize: '.82rem', marginTop: '.4rem' }}>
                ⚠️ PayPal ne supporte pas le MAD. Utilisez USD ou EUR.
              </p>
            </div>
          </div>

          {/* ✅ NOUVEAU — Paiement à la livraison */}
          <div className="card" style={{ padding: '2rem', marginBottom: '1.5rem' }}>
            <h2 style={{ marginBottom: '1.5rem' }}>🚚 Paiement à la livraison</h2>
            <p style={{ color: '#888', fontSize: '.9rem', marginBottom: '1.5rem' }}>
              Activez ou désactivez le bouton "Commander (paiement à la livraison)" sur les pages produits.
            </p>
            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
              <div
                onClick={!codSaving ? handleToggleCOD : undefined}
                style={{
                  width: 52, height: 28, borderRadius: 14,
                  cursor: codSaving ? 'not-allowed' : 'pointer',
                  transition: 'background .2s',
                  background: cashOnDelivery ? '#1a1a1a' : '#d1d5db',
                  position: 'relative', flexShrink: 0,
                  opacity: codSaving ? 0.6 : 1,
                }}
              >
                <div style={{
                  position: 'absolute', top: 3,
                  left: cashOnDelivery ? 26 : 3,
                  width: 22, height: 22, borderRadius: '50%', background: 'white',
                  transition: 'left .2s', boxShadow: '0 1px 4px rgba(0,0,0,0.2)',
                }} />
              </div>
              <span style={{ fontWeight: 600, color: cashOnDelivery ? '#1a1a1a' : '#9ca3af' }}>
                {codSaving ? 'Mise à jour...' : cashOnDelivery ? 'Activé' : 'Désactivé'}
              </span>
            </div>
          </div>

          {/* Devise */}
          <div className="card" style={{ padding: '2rem', marginBottom: '1.5rem' }}>
            <h2 style={{ marginBottom: '1.5rem' }}>💱 Devise d'affichage</h2>
            <p style={{ color: '#888', fontSize: '.9rem', marginBottom: '1.25rem' }}>
              Choisissez la devise affichée sur toutes les pages du site.
            </p>
            <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
              {CURRENCIES.map(cur => (
                <label key={cur.code} style={{
                  display: 'flex', alignItems: 'center', gap: '.6rem',
                  padding: '.75rem 1.25rem', borderRadius: 8, cursor: 'pointer',
                  border: settings.currency === cur.code ? '2px solid #1a1a1a' : '2px solid #e5e7eb',
                  background: settings.currency === cur.code ? '#1a1a1a' : 'white',
                  color: settings.currency === cur.code ? 'white' : '#1a1a1a',
                  fontWeight: 600, transition: 'all .2s',
                }}>
                  <input type="radio" name="currency" value={cur.code}
                    checked={settings.currency === cur.code}
                    onChange={() => setSettings(s => ({ ...s, currency: cur.code }))}
                    style={{ display: 'none' }} />
                  <span style={{ fontSize: '1.2rem' }}>{cur.symbol}</span>
                  {cur.label}
                </label>
              ))}
            </div>
            <p style={{ marginTop: '1rem', color: '#aaa', fontSize: '.82rem' }}>
              Aperçu : <strong>{settings.currency === 'MAD' ? '299.00 DH' : settings.currency === 'EUR' ? '€29.99' : '$29.99'}</strong>
            </p>
          </div>

          <button type="submit" className="btn btn-primary" disabled={saving}>
            {saving ? 'Sauvegarde...' : '💾 Sauvegarder les paramètres'}
          </button>
        </form>
      </main>
    </div>
  );
};

export default AdminSettings;